import React, { Fragment } from "react";
import Plot from "react-plotly.js";
import { Card, CardContent, useTheme } from "@mui/material";
import IncomeChart from "components/cards/income/IncomeChart.component";
import { useTranslation } from "react-i18next";

const LineChartPlotly = ({
    data,
    titleChart,
    yLabel,
    xLabel,
    isLoading,
    shapes = [],
    yRange,
    yVisible = true,
    showlegend = true,
    xRange
}) => {
    const theme = useTheme();
    const { i18n } = useTranslation()

    return isLoading ? (
        <IncomeChart />
    ) : (
        <Fragment>
            <Card sx={{ height: '100%', }}>
                <CardContent sx={{ "&.MuiCardContent-root": { padding: 0 }, width: '100%', }}>
                    <Plot
                        config={{ responsive: true, locale: i18n?.language ? i18n.language : 'it' }}
                        data={data}
                        useResizeHandler={true}
                        layout={{
                            autosize: true,
                            showlegend: showlegend,
                            margin: {
                                l: 60,
                                r: 40,
                                b: 60,
                                t: 40,
                                pad: 5
                            },

                            shapes: shapes,
                            plot_bgcolor:
                                theme.palette.mode === "dark"
                                    ? theme.palette.background.default
                                    : "white",
                            paper_bgcolor:
                                theme.palette.mode === "dark"
                                    ? theme.palette.background.default
                                    : "white",
                            title: titleChart,
                            titlefont: {
                                size: 14,
                                color:
                                    theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
                            },
                            xaxis: {
                                title: xLabel,
                                tickfont: {
                                    size: 11,
                                    color:
                                        theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
                                },
                                titlefont: {
                                    size: 12,
                                    color:
                                        theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
                                },
                                range: xRange,
                                autorange: true,

                            },
                            yaxis: {
                                title: yLabel,
                                titlefont: {
                                    width: 1,
                                    size: 11,
                                    color:
                                        theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
                                },
                                tickfont: {
                                    size: 12,
                                    color:
                                        theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
                                },
                                range: yRange,
                                showticklabels: yVisible,
                            },
                            legend: {
                                x: 1,
                                y: 1.338,
                                xanchor: 'right',
                                font: {
                                    size: 10,
                                    color:
                                        theme.palette.mode === "dark" ? "white" : 'black',
                                },
                                bgcolor: "rgba(255, 255, 255, 0)",
                                bordercolor: "rgba(255, 255, 255, 0)",

                            },
                            marker: {
                                color: 'blue',
                                line: {
                                    color: 'white',
                                    width: 1
                                }
                            },

                        }}
                        style={{ minHeight: 260, }}

                    />
                </CardContent>
            </Card>
        </Fragment>
    );
};

export default LineChartPlotly;
